import * as form from '../form';

export const financialBankruptcy = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        CourtNumberIdk: form.notapplicable(xitem.CourtNumberIdk),
        PetitionType: form.radio(xitem.PetitionType),
        CourtAddress: form.location(xitem.CourtAddress),
        CourtInvolved: form.text(xitem.CourtInvolved),
        CourtNumber: form.text(xitem.CourtNumber),
        NameDebt: form.name(xitem.NameDebt),
        TotalAmount: form.number(xitem.TotalAmount),
        TotalAmountEstimated: form.checkbox(xitem.TotalAmountEstimated),
        DateFiled: form.datecontrol(xitem.DateFiled),
        DateDischarged: form.datecontrol(xitem.DateDischarged),
        DateDischargedNotApplicable: form.notapplicable(xitem.DateDischargedNotApplicable),
        HasDischargeExplanation: form.branch(xitem.HasDischargeExplanation),
        DischargeExplanation: form.textarea(xitem.DischargeExplanation),
        Trustee: form.text(xitem.Trustee),
        PvqTrustee: form.name(xitem.PvqTrustee),
        TrusteeAddress: form.location(xitem.TrusteeAddress),
        TrusteeNotApplicable: form.notapplicable(xitem.TrusteeNotApplicable),
        TrusteeAddressNotApplicable: form.notapplicable(xitem.TrusteeAddressNotApplicable),
        WasFiledJointly: form.branch(xitem.WasFiledJointly),
        JointFileName: form.name(xitem.JointFileName),
        PvqTrusteeNameNotApplicable: form.notapplicable(xitem.PvqTrusteeNameNotApplicable),
      },
    };
  });
  return {
    HasBankruptcy: form.branch(data.HasBankruptcy),
    List: form.collection(items, (data.List || {}).branch),
  };
};
